import { render, staticRenderFns } from "./PendingProductListTop.vue?vue&type=template&id=796ab9f4&scoped=true&"
import script from "./PendingProductListTop.vue?vue&type=script&lang=js&"
export * from "./PendingProductListTop.vue?vue&type=script&lang=js&"
import style0 from "./PendingProductListTop.vue?vue&type=style&index=0&id=796ab9f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ab9f4",
  null
  
)

export default component.exports